const logXtremePush = (prefix, type, name, data) => {
  const theName = `${prefix}_${name}`;

  let theData;

  if (data) {
    theData = data;
  }

  console.log("logging to xtremepush", type, theName, theData);

  window.xtremepush(type, theName, theData);
};

export default logXtremePush;
